import { css } from '@emotion/core'

export default {
  reprocessFolder: css`
    padding: 0;
  `,
  reprocessFolderButton: css`
    padding-bottom: 16px;
  `,
}
